<div class="marquee-snap">
  <div class="marquee-track" #track>
    @for (marquee of marquees; track $index) {
      <div class="marquee-item">
        {{ marquee | translate }}
      </div>
    }
  </div>
</div>
